import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    background: transparent linear-gradient(180deg, #000000 0%, #3C0043 100%) 0 0 no-repeat padding-box;
`;
